import { withStyles } from '@/components/Buttons/Core/withStyles';
import { BaseButton } from '@/components/Buttons/Core/BaseButton';

export const PrimaryButton = withStyles(BaseButton, {
    light: 'bmwLightBlue.main',
    dark: 'bmwLightBlue.main',
    textStyle: {
        color: 'white',
        light: 'white',
        dark: 'white'
    },
});
